import { DocumentStatusDto } from 'src/app/shared/interfaces/documents/document-status-dto.interface';
import { SpecificStatus } from './specific-status';

export class GlobalStatus {
  public id: number;
  public code?: string;
  public description?: string;
  public color?: string;
  public displayOrder: number;
  public specificStatutes: SpecificStatus[];
}

export class GlobalStatusKanban extends GlobalStatus {
  public documentstatus: DocumentStatusDto[];
  public totalItems: number;

  constructor(data: GlobalStatus) {
    super();
    Object.assign(this, data);
  }
}

export class GlobalStatusParams {
  id?: number;
  code?: string;
  key?: string;
}
